import { APIMethod, fetchData } from "@client";

export async function updateCompanyLogoQuery(logo) {
  await fetchData("/company/logo", APIMethod.PUT, { data: { logo } });
}
